import GridTable from "@/components/GridTable";
import Loader from "@/components/Loader";

import { GridApi, GridReadyEvent } from "ag-grid-community";
import React, { useState } from "react";

import { useAlertUpdate } from "./hooks";
import { alertColumns, defaultColDef } from "../constants";
import AlertSetting from "./AlertSetting";
import TableControl from "../TableControl";
import Checkbox from "./Checkbox";
import { useWatchListContext } from "@/modules/Watchlist/hooks";

export default () => {
  const [gridApi, setGridApi] = useState<GridApi>();
  const [alertLoading, setAlertLoading] = useState(false);
  const { userAlertLimit } = useAlertUpdate();
  const { watchlistData } = useWatchListContext();
  const checkbox = Checkbox();

  return (
    <div style={{ minHeight: 300 }}>
      <TableControl gridApi={gridApi} />

      <AlertSetting setAlertLoading={setAlertLoading} />
      {alertLoading ? (
        <Loader />
      ) : (
        <GridTable
          animateRows
          extStyle={{ height: "100%" }}
          columnDefs={alertColumns}
          defaultColDef={defaultColDef}
          enableRangeSelection={false}
          onGridReady={onGridReady}
          rowData={injectAlertLimit()}
          rowDragManaged
          suppressHorizontalScroll
          enterMovesDownAfterEdit
          pagination={true}
          paginationPageSize={15}
          multiSortKey={"ctrl"}
          localeText={{ noRowsToShow: "No stock added in current watchlist." }}
          frameworkComponents={{ checkbox }}
        />
      )}
    </div>
  );

  function onGridReady(params: GridReadyEvent) {
    setGridApi(params.api);
    params.api.refreshCells();
    params.columnApi.autoSizeAllColumns();
  }

  function injectAlertLimit() {
    return watchlistData.map(e => ({
      ...e,
      ...userAlertLimit.find(a => a.ticker === e.trading_code && a.exchange === e.exchange)
    }));
  }
};
